import { PersonBus } from "./PersonBus";
import { CustomerLogoBus } from "./CustomerLogoBus";
import { BaseBus } from "./BaseBus";
import { CommonFunctions } from "../static/common-functions";
import { DateFunctions } from "../static/date-functions";

export class UnionTimeTypeBenefitExclusionBus extends BaseBus
{
    constructor(busObj: UnionTimeTypeBenefitExclusionBus = null) {
        super(busObj);
    }
    CID(): any {
        return this.unionTimeTypeBenefitExclusionId;
    }
    // get hasId(): boolean {
    //     return this.CID() !== undefined && this.CID() !== null;
    // }
    unionTimeTypeBenefitExclusionId: any;
    unionId: any;
    timeTypeId: any;
    isActive: boolean;
    deduction: boolean;
    benefit: boolean;
    union: string;
    timeType: string;
    updatedBy: String;
    updatedOn: Date
}
